import { stateT } from "../../types";

export const getActiveEnvironmentId = (state: stateT) => {
  return state.ui.activeEnvironmentId;
};

export const getEnvironments = (state: stateT) => {
  return state.ui.environments;
};

export const getActiveEnvironmentStage = (state: stateT) => {
  const activeEnvironmentId = getActiveEnvironmentId(state);
  return getEnvironments(state)?.find(
    (environment) => environment.id === activeEnvironmentId
  );
};

export const getEnvironmentActiveValues = (state: stateT) => {
  return state.ui.environmentActiveValues;
};
